import { DocumentMetadata } from "../../models";
import { SearchResult } from "../../models/search-result";
import { bijlagenPath, documentUrl, hoofddocumentenPath, metadataPath } from "../../utils/api-path";
import { logApiCall } from "../../utils/ApiLogger";
import { getHoofdDocRelatie, isBijlageDocument } from "../../utils/Relaties";
import { StringSanitizer } from "../../utils/StringSanitizer";
import { IDocumentMetadataApi } from "../document-metadata-v2";

const stringSanitizer = new StringSanitizer();

function safeParse<T>(jsonString: string): T {
  return JSON.parse(jsonString) as T;
}

const MOCK_HOOFDDOCUMENT_PID = "https://open.overheid.nl/documenten/11a5e4b7-23ca-487b-9e26-8795b7657e11";
let count = 0;

const newPid = (hoofddocumentId?: string): string =>
  hoofddocumentId
    ? `https://open.overheid.nl/documenten/22b6f5c8-34db-598c-af37-9806c876${String(++count).padStart(4, "0")}`
    : MOCK_HOOFDDOCUMENT_PID;

const oasV2 = () => process.env.REACT_APP_OAS_V2 === "true";
const publicaties = () => oasV2() || process.env.REACT_APP_WEBLOCATIE === "true";
const url = (path = "") =>
  `${publicaties() ? process.env.REACT_APP_METADATA_API_ENDPOINT_V2 : process.env.REACT_APP_METADATA_API_ENDPOINT}` +
  `/${publicaties() ? "publicaties" : "metadata"}${path ? `/${path}` : ""}`;

export const mockHoofdDoc: DocumentMetadata = {
  document: {
    // weblocatie:
    //   "https://open.rijkswaterstaat.nl/publish/pages/180398/8-1_2012-08-23_modelbeschikking_vergunning_laadstation_1_1.pdf",
    creatiedatum: "2022-09-11T12:35:46.43498474Z",
    pid: "https://open.overheid.nl/documenten/9fa5e4b7-23ca-487b-9e26-8795b7657eaa",
    identifiers: ["DOC100323 - 1325"],
    publisher: {
      id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1034",
      label: "ministerie van Binnenlandse Zaken en Koninkrijksrelaties",
    },
    language: {
      id: "http://publications.europa.eu/resource/authority/language/NLD",
      label: "Nederlands",
    },
    omschrijvingen: ["Omschrijving"],
    titelcollectie: {
      officieleTitel: "DOC100323 - 1325ftrft",
    },
    classificatiecollectie: {
      documentsoorten: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_386e74cb",
          label: "convenant",
        },
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_0d0e9b52",
          label: "nader rapport",
        },
      ],
      themas: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/top/c_2408fb5a",
          label: "cultureel erfgoed",
        },
      ],
      informatiecategorieen: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_139c6280",
          label: "wet of algemeen verbindend voorschrift",
        },
      ],
    },
    documenthandelingen: [
      {
        soortHandeling: {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_641ecd76",
          label: "vaststelling",
        },
        atTime: "2023-03-10T12:25:25.386Z",
        wasAssociatedWith: {
          id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1034",
          label: "ministerie van Binnenlandse Zaken en Koninkrijksrelaties",
        },
      },
      {
        soortHandeling: {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_641ecd76",
          label: "vaststelling",
        },
        atTime: "2023-04-10T12:25:25.386Z",
        wasAssociatedWith: {
          id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1034",
          label: "ministerie van Binnenlandse Zaken en Koninkrijksrelaties",
        },
      },
    ],
    publicatiebestemming: ["rijksoverheid.nl"],
    zichtbaarheidsdatumtijd: "9999-12-31T12:00:00.000Z",
    medeverantwoordelijken: [
      {
        id: "https://identifier.overheid.nl/tooi/id/so/so0261",
        label: "Amstelland en Meerlanden Werkorganisatie",
      },
    ],
    verantwoordelijke: {
      id: "https://identifier.overheid.nl/tooi/id/zbo/zb000319",
      label: "Keuringsinstanties ex Wet milieubeheer en ex Regeling handel in emissierechten",
    },
  },
  plooiIntern: {
    publicatiestatus: "latere-publicatie",
    // dcnId: "plooi-api-9fa5e4b7-23ca-487b-9e26-8795b7657eaa",
    // sourceLabel: "plooi-api",
  },
  documentrelaties: [
    {
      relation: "https://open.overheid.nl/documenten/ce3c68b6-c68d-45c0-ab43-123f6c920dc7",
      // "role": "https://identifier.overheid.nl/tooi/def/thes/kern/c_4d1ea9ba"
      role: "https://identifier.overheid.nl/tooi/def/thes/kern/c_05f4a5f3",
    },
  ],
  versies: [
    {
      openbaarmakingsdatum: "2023-03-10",
      // wijzigingsdatum: "2023-03-10",
      mutatiedatumtijd: "2023-03-10T12:42:44.215415468Z",
      bestanden: [
        {
          bestandsnaam: "metadata.json",
          label: "metadata",
        },
        {
          bestandsnaam: "BestandsnaamHoofdDoc.pdf",
          label: "file",
        },
      ],
    },
  ],
};

export const mockBijlageDocument: DocumentMetadata = {
  document: {
    zichtbaarheidsdatumtijd: "2023-09-11T12:35:46.43498474Z",
    creatiedatum: "2022-09-11T12:35:46.43498474Z",
    pid: "https://open.overheid.nl/documenten/ce3c68b6-c68d-45c0-ab43-123f6c920dc7",
    identifiers: ["Bijlage100323 - 1330"],
    publisher: {
      id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1034",
      label: "ministerie van Binnenlandse Zaken en Koninkrijksrelaties",
    },
    language: {
      id: "http://publications.europa.eu/resource/authority/language/NLD",
      label: "Nederlands",
    },
    publicatiebestemming: ["rijksoverheid.nl"],
    omschrijvingen: ["Omschrijving"],
    titelcollectie: { officieleTitel: "Bijlage100323 - 1330" },
    classificatiecollectie: {
      documentsoorten: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_386e74cb",
          label: "convenant",
        },
      ],
      themas: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/top/c_2408fb5a",
          label: "cultureel erfgoed",
        },
      ],
      informatiecategorieen: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_139c6280",
          label: "wet of algemeen verbindend voorschrift",
        },
      ],
    },
    documenthandelingen: [
      {
        soortHandeling: {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_641ecd76",
          label: "vaststelling",
        },
        atTime: "2023-03-10T12:30:16.803Z",
        wasAssociatedWith: {
          id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1034",
          label: "ministerie van Binnenlandse Zaken en Koninkrijksrelaties",
        },
      },
    ],
    extraMetadata: [
      {
        velden: [
          {
            key: "test",
            values: ["xczxcxzc", "sadsa"],
          },
          {
            key: "test1",
            values: ["xczxcxzc1", "sadsa1"],
          },
        ],
      },
    ],
  },
  plooiIntern: {
    publicatiestatus: "gepubliceerd",
    // dcnId: "plooi-api-ce3c68b6-c68d-45c0-ab43-123f6c920dc7",
    // sourceLabel: "plooi-api",
  },
  documentrelaties: [
    {
      relation: "https://open.overheid.nl/documenten/9fa5e4b7-23ca-487b-9e26-8795b7657eaa",
      role: "https://identifier.overheid.nl/tooi/def/thes/kern/c_4d1ea9ba",
    },
  ],
  versies: [
    {
      openbaarmakingsdatum: "2023-03-10",
      // wijzigingsdatum: "2023-03-10",
      mutatiedatumtijd: "2023-03-10T12:35:46.43498474Z",
      bestanden: [
        {
          bestandsnaam: "metadata.json",
          label: "metadata",
        },
        {
          bestandsnaam: "Bestandsnaam.pdf",
          label: "file",
        },
      ],
    },
  ],
};

export const mockSearchResult: SearchResult = {
  document: {
    pid: "https://open.overheid.nl/documenten/d059e50f-8a49-45cd-b5a7-c12ca0a31ef0",
    creatiedatum: "2023-10-04T12:00:00Z",
    publisher: {
      id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1034",
      label: "ministerie van Binnenlandse Zaken en Koninkrijksrelaties",
    },

    opsteller: {
      id: "https://identifier.overheid.nl/tooi/id/organisatie_onbekend",
      label: "Onbekend",
    },
    identifiers: ["Identificatiekenmerk"],
    language: {
      id: "http://publications.europa.eu/resource/authority/language/NLD",
      label: "Nederlands",
    },
    titelcollectie: {
      officieleTitel: "Bijlage1696409672299",
    },
    classificatiecollectie: {
      documentsoorten: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_2977c34f",
          label: "beslisnota",
        },
      ],
      themas: [
        {
          id: "https://identifier.overheid.nl/tooi/id/thema_onbekend",
          label: "Onbekend",
        },
      ],
      informatiecategorieen: [
        {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_139c6280",
          label: "wet of algemeen verbindend voorschrift",
        },
      ],
    },
    documenthandelingen: [
      {
        soortHandeling: {
          id: "https://identifier.overheid.nl/tooi/def/thes/kern/c_dfcee535",
          label: "ontvangst",
        },
        atTime: "2023-10-04T08:54:35.494Z",
        wasAssociatedWith: {
          id: "https://identifier.overheid.nl/tooi/id/ministerie/mnre1010",
        },
      },
    ],
    publicatiebestemming: ["rijksoverheid.nl"],
    geldigheid: {
      begindatum: "2023-10-04T12:00:00Z",
    },
  },
  versies: [
    {
      mutatiedatumtijd: "2023-10-04T08:54:39.8445618Z",
      openbaarmakingsdatum: "2023-10-04",
      nummer: 1,
      oorzaak: "oorzaak",
      redenVerwijderingVervanging: "redenVerwijderingVervanging",
    },
  ],
  plooiIntern: {
    publicatiestatus: "gepubliceerd",
    dcnId: "dcnId",
    aanbieder: "aanbieder",
    extId: ["exId"],
    sourceLabel: "sourceLabel",
  },
  documentrelaties: [
    {
      relation: "https://open.overheid.nl/documenten/9fa5e4b7-23ca-487b-9e26-8795b7657eaa",
      role: "https://identifier.overheid.nl/tooi/def/thes/kern/c_4d1ea9ba",
    },
  ],
};

export class MockDocumentMetadataApi implements IDocumentMetadataApi {
  createMetadataSession(
    meta: DocumentMetadata,
    hoofddocumentId?: string
  ): Promise<{ uploadUrl: string; pid: string; sessionId: string }> {
    logApiCall(
      "POST",
      url(oasV2() ? (hoofddocumentId ? bijlagenPath(hoofddocumentId) : hoofddocumentenPath()) : ""),
      oasV2() ? { document: meta.document } : { document: meta.document, documentrelaties: meta.documentrelaties ?? [] }
    );

    if (meta.document.titelcollectie?.officieleTitel === "error") {
      return Promise.reject(new Error("Error creating metadata session"));
    }

    const pid = newPid(hoofddocumentId);
    const id = stringSanitizer.extractIdentifierFromPid(pid);
    return Promise.resolve({
      uploadUrl: oasV2()
        ? documentUrl(process.env.REACT_APP_DOCUMENT_API_ENDPOINT_V2 as string, id, hoofddocumentId)
        : `${process.env.REACT_APP_DOCUMENT_API_ENDPOINT}/documenten/${id}`,
      pid,
      sessionId: id,
    });
  }

  updateMetadata(
    meta: DocumentMetadata,
    id: string,
    redenId?: string,
    hoofddocumentId?: string
  ): Promise<DocumentMetadata> {
    logApiCall("PUT", url(oasV2() ? metadataPath(id, hoofddocumentId) : id), {
      document: meta.document,
      ...(oasV2() ? {} : { documentrelaties: meta.documentrelaties ?? [] }),
      ...(redenId ? { infoWijziging: { redenVerwijderingVervanging: redenId } } : {}),
    });

    if (meta.document.titelcollectie?.officieleTitel === "error") {
      return Promise.reject(new Error("Error creating metadata session"));
    }
    return Promise.resolve(safeParse<DocumentMetadata>(JSON.stringify(mockBijlageDocument)));
  }

  fetchMetadata(id: string, _hoofddocId?: string): Promise<DocumentMetadata> {
    logApiCall("GET", url(id));

    if (id === stringSanitizer.extractIdentifierFromPid(mockHoofdDoc.document.pid))
      return Promise.resolve(mockHoofdDoc);

    return Promise.resolve(mockBijlageDocument);
  }

  getDocumentBijlages(id: string): Promise<SearchResult[]> {
    logApiCall("GET", url(oasV2() ? bijlagenPath(id) : `${id}/bijlagen`));

    return new Promise((resolveOuter) => {
      resolveOuter(
        new Promise((resolveInner) => {
          setTimeout(resolveInner, 500);
        })
      );
    }).then((_) => [mockSearchResult] as SearchResult[]);
  }

  async depubliceerMetadata(id: string, redenId: string, hoofddocumentId?: string): Promise<any> {
    const hoofddocId = hoofddocumentId ?? (oasV2() ? await this.searchHoofddocumentId(id) : undefined);
    logApiCall("DELETE", url(oasV2() ? metadataPath(id, hoofddocId) : id), {
      infoVerwijdering: { redenVerwijderingVervanging: redenId },
    });

    return Promise.resolve({ response: new Response() });
  }

  private async searchHoofddocumentId(id: string): Promise<string | undefined> {
    const meta = await this.fetchMetadata(id);
    const relaties = meta.documentrelaties ?? [];
    if (!isBijlageDocument(relaties)) return undefined;

    const relatie = getHoofdDocRelatie(relaties);
    return relatie ? stringSanitizer.extractIdentifierFromPid(relatie) : undefined;
  }
}
